import { useCallback } from 'react'
import styled from 'styled-components'

import { IconButton } from '../shared/styledComponents'

const Container = styled.div<{ hideContents: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  height: 50px;
  background-color: ${props => props.hideContents ? '#CCCED2' : '#717173' };
  border: solid 1px #a9a9a9;
  color: ${props => props.hideContents ? '#000' : '#fff' };
`

const Text = styled.span`
  margin: auto 0 auto 20px;
  font-family: Helvetica;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: -0.2px;
  text-align: left;
`
const IconCollapse = styled.i`
`

const IconExpand = styled.i`
`
const Close = styled(IconButton)`
  margin-top: 5px;
  margin-left: auto;
  margin-right: 10px;
  display: inline-block;
  height: 40px;
`

type PreviewCategoryCardProps = {
  title: string
  hideContents: boolean
  category: string
  toggleCategory(category: string): void
}

const PreviewCategoryCard = (props: PreviewCategoryCardProps) => {
  const { toggleCategory, title, hideContents, category } = props
  const onToggle = useCallback(() => {
    toggleCategory(category)
  }, [category, toggleCategory])
  return (
    <Container hideContents={hideContents}>
      <Text id='categoryTitle'>{title}</Text>
      <Close className='preview-cat-card-close' onClick={onToggle}>
        {hideContents
          ? <IconCollapse
              className="sprite sprite-Accordion_collasped"
              aria-label="Expand"
              role="button"
              title="Expand"
              aria-expanded="false"
            />
          : <IconExpand
              className="sprite sprite-Accordion_expanded"
              aria-label="Collapse"
              role="button"
              title="Collapse"
              aria-expanded="true"
            />
        }
      </Close>
    </Container>
  )
}

export { PreviewCategoryCard }
